import { render, staticRenderFns } from "./V2PublicWishlist.vue?vue&type=template&id=581c21d0&scoped=true&"
import script from "./V2PublicWishlist.vue?vue&type=script&lang=js&"
export * from "./V2PublicWishlist.vue?vue&type=script&lang=js&"
import style0 from "./V2PublicWishlist.vue?vue&type=style&index=0&id=581c21d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c21d0",
  null
  
)

export default component.exports